import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** IFRS判定の重要性判定 */
enum IfrsImportanceAssessment {
  notExecute = '0',
  execute = '1',
}

const nameConfig = {
  notExecute: new Map([
    [Locale.ja, '実施しない'],
    [Locale.en, 'Not Execute'],
  ]),
  execute: new Map([
    [Locale.ja, '実施する'],
    [Locale.en, 'Execute'],
  ]),
};

const toEnum = rawValueToEnum(IfrsImportanceAssessment, IfrsImportanceAssessment.notExecute);
const toDisplay = enumToName(IfrsImportanceAssessment, nameConfig);
const toDisplayWithPrefix = enumToName(IfrsImportanceAssessment, nameConfig, { prefix: true });

export const ifrsImportanceAssessment = {
  enum: IfrsImportanceAssessment,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { IfrsImportanceAssessment };
